import { Skeleton } from './Skeleton';

/**
 * Skeleton for category tabs bar
 */
export function CategoryTabsSkeleton({ tabCount = 5 }: { tabCount?: number }) {
  return (
    <div className="bg-tg-bg border-b border-tg-secondary-bg shadow-sm">
      <div className="flex items-center">
        {/* Sections button skeleton */}
        <Skeleton className="flex-shrink-0 w-10 h-10 ml-2 mr-1 rounded-full" />

        {/* Category tabs skeleton */}
        <div className="flex-1 flex overflow-x-auto px-2 py-2 gap-2">
          {Array.from({ length: tabCount }).map((_, i) => (
            <Skeleton
              key={i}
              className="flex-shrink-0 h-9 rounded-full"
              style={{ width: 70 + Math.random() * 40 }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

